import { Skeleton } from "@mui/material";

export function DashboardGraphLoading() {

    return (
        <>
            <Skeleton 
                variant="rounded" 
                width='100%'
                height='100%'
            />
        </> 
    );
}
